module.exports = __webpack_public_path__ + "static/media/messenger.4556ce9b.svg";